import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Card, Container, Form, Row, Col, Table, Tabs, Tab, Button, Modal } from 'react-bootstrap';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { actualizarIndemnizacion, actualizarProvisiones, getCasoImplicado, getParametros, verPreInforme, autorizaRechazaReserva, registraValorizacionPEC } from '../../../api/api-visar-provision';
import { descargarArchivo } from '../../../common/descargarArchivo';
import { formato_rut, today, minDate, getBase64, moneyPunto, formatoMonto, resetFormatoMonto, resetFormatoMontoSinPunto, validaNumeros, formatearNumero } from '../../../common/Formatos';
import { validationSchemasVisaProvision } from '../../../common/validation-Schemas-visa-provision';
import CoberturaPoliza from './components/cobertura-poliza';
import { obtenerProvImplicadosHistorial, obtenerProvisionesImplicados } from '../../../store/actions/visar-provision-action';
import { obtenerTareasPendientes } from '../../../store/actions/administracion-caso-action';
import { FaSearch } from "react-icons/fa";
import { MdComment } from 'react-icons/md';
import Mensajes from '../../mensajes';
import GrillaPrevisionesImplicados from './components/grillaProvisionesImplicados';

const Provisiones = ({ action, implicado, handleClose, setShowImplicadosHistorial, origenVisar, setTipoMovimientoGrilla, idTrxOrigen, secuenciaInforme, onTareaGestionada}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { rutUsuario, roles, codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const data_encargado = useSelector(state => state.encargadoCompaniaReducer);
    const visar_provision = useSelector(state => state.visarProvisionReducer);
    const { llaves } = data_encargado;
    const { cfg_form44, comboMonedas, comboInstanciasProvisiones, listaProvisionesVigentes, comboResponsabilidadAsegurado, amparosCia, reservaCia, comboDecision } = visar_provision;

    const [dataReady, setDataReady] = useState(false);
    const [stateMoneda, setStateMoneda] = useState("");
    const [stateFechaActualizacion, setStateFechaActualizacion] = useState(today());
    const [stateComentario, setStateComentario] = useState("");
    const [stateComentarioVizacion, setStateComentarioVizacion] = useState("");
    const [stateInstanciaProvision, setStateInstanciaProvision] = useState("");
    const [stateSituacionProvision, setStateSituacionProvision] = useState("245005");
    const [stateMontos, setStateMontos] = useState({});
    const [stateMontoTotal, setStateMontoTotal] = useState(0);
    const [involucrado, setInvolucrado] = useState({});
    const [fechaActualizaPrevision, setFechaActualizaPrevision] = useState("");
    const [fechaSiniestro, setFechaSiniestro] = useState("");
    const [parametro, setParametro] = useState("");
    const [secuencia, setSecuencia] = useState("");
    const [key, setKey] = useState('');
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [folioDoc, setFolioDoc] = useState("");
    const [permissionCabecera, setPermissionCabecera] = useState("");
    const [permissionGrilla, setPermissionGrilla] = useState("");
    const [permissionButtons, setPermissionButtons] = useState("");
    const [permissionComboSituacion, setPermissionComboSituacion] = useState("");
    const [monedaSelected, setMonedaSelected] = useState("");
    const [changeSituacionProvision, setChangeSituacionProvision] = useState(false);
    const [situacionProvision, setSituacionProvision] = useState("");
    const [showModalTotal, setShowModalTotal] = useState(false);
    const [registraProvision, setRegistraProvision] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [dataResult, setDataResult] = useState(false);
    const [showModalProvisionesImplicado, setShowModalProvisionesImplicado] = useState(false);

    const [stateResponsabilidadAsegurado, setStateResponsabilidadAsegurado] = useState("");
    const [stateAmparoAfectado, setStateAmparoAfectado] = useState("");
    const [amparoAfectado, setAmparoAfectado] = useState("");
    const [statePorcRegla, setStatePorcRegla] = useState("");
    const [statePorcConfirmado, setStatePorcConfirmado] = useState("");
    const [stateMontoReserva, setStateMontoReserva] = useState("");

    const [montoReserva, setMontoReserva] = useState("");
    const [montoReservaNoFormato, setMontoReservaNoFormato] = useState("");
    const [amparosAfectados, setAmparosAfectados] = useState([]);
    const [amparosCaso, setAmparosCaso] = useState([]);
    const [stateMontosAmparosCaso, setStateMontosAmparosCaso] = useState({});
    const [stateTotalAmparosCaso, setStateTotalAmparosCaso] = useState(0);

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [pendingData, setPendingData] = useState(null);
    const [stateComentarioAutorizacion, setStateComentarioAutorizacion] = useState("");
    const [errorComentario, setErrorComentario] = useState('');
    const [situacionReserva, setSituacionReserva] = useState('');
    const [stateDecisionCia, setStateDecisionCia] = useState('');
    const [montoAutorizado, setMontoAutorizado] = useState("");
    const [errorMontoAutorizado, setErrorMontoAutorizado] = useState('');

    const [stateObsCia, setStateObsCia] = useState({});
    const [showObsAboModal, setShowObsAboModal] = useState(false);
    const [obsAboModalContent, setObsAboModalContent] = useState('');

    const initialDecisionCia = useRef('');
    const initialMontoAutorizado = useRef('');
    const initialMontos = useRef({});
    const initialComentario = useRef('');
    const initialInstancia = useRef('');
    const initialPorcConfirmado = useRef('');
    const initialResponsabilidad = useRef('');
    const initialAmparoAfectado = useRef('');


    const montoReservaTotalCia = (reservaCia?.reservaCia?.coberturasPoliza || [])
        .filter(r => r.montoPretencion > 0)
        .reduce((sum, r) => sum + Number(r.montoPretencion || 0), 0);

    const ID_SITUACION_INFORME_POR_AUTORIZAR = 245006;
    const ID_SITUACION_INFORME_OBJETADO = 245008;
    const ID_SITUACION_INFORME_VIGENTE = 245002;

    const ID_TAREA_AUTOR_RESERVA_CASO = 27;
    const ID_TAREA_VISAR_VAL_PEC = 29;

    const isPEC = action !== "provision";

    const [tituloModal, setTituloModal] = useState('');

    useEffect(() => {
        if (!dataReady) {
            setPermissionCabecera(false); setPermissionGrilla(false); setPermissionButtons(false); setPermissionComboSituacion(false);
            return;
        }
        action === "provision" ? permissionProvision() : permissionIndemnizacion();
    }, [stateSituacionProvision, dataReady]);

    useEffect(() => {
        if (comboMonedas) {
            if (comboMonedas.length === 1) setStateMoneda(comboMonedas[0].id);
            setMonedaSelected(comboMonedas.find(m => Number(m.id) === Number(stateMoneda))?.nombreCorto);
        }
    }, [comboMonedas, stateMoneda]);

    useEffect(() => {
        if (!listaProvisionesVigentes?.listaProvisionesVigentes?.coberturasPoliza) return;
        if (amparosCia === undefined) return;
        if (!comboResponsabilidadAsegurado?.comboResponsabilidadAsegurado) return;

        let cancelled = false;
        setDataReady(false);
        setLoading(true);

        // — Sincrónico: coberturas —
        let total = 0;
        let auxMontos = {};
        let auxObsCia = {};
        listaProvisionesVigentes.listaProvisionesVigentes.coberturasPoliza.forEach(pre => {
            const key = `state${pre.codigoCobertura}`;
            auxMontos[key] = validateMontoMoneda(pre.montoPretencion, 'format');
            total += Number(validateMontoMoneda(pre.montoPretencion, 'reset_format'));
            auxObsCia[`obscia${pre.codigoCobertura}`] = pre.obsAnalistaCIA || '';
        });
        initialMontos.current = { ...auxMontos };
        setStateMontos(auxMontos);
        setStateObsCia(auxObsCia);
        setStateMontoTotal(validateMontoMoneda(total, 'format'));

        const tipoMovimiento = action === "provision" ? 261002 : 261003;
        setAmparosAfectados(amparosCia?.amparosCia?.coberturasPoliza?.filter(c => c.totalizaGrpAmparo == tipoMovimiento).map(c => ({ id: c.codigoCobertura, nombre: c.cobertura })));
        setMontoReserva(parseInt(total * (Number(statePorcConfirmado) / 100)));

        const amparosCasoFiltrado = amparosCia?.amparosCia?.coberturasPoliza?.filter(c => c.totalizaGrpAmparo != tipoMovimiento && c.actualizaMonto === "S");
        setAmparosCaso(amparosCasoFiltrado);
        let totalAmparo = 0;
        let auxMontosAmparo = {};
        amparosCasoFiltrado?.forEach(pre => {
            const key = `state${pre.codigoCobertura}`;
            auxMontosAmparo[key] = validateMontoMoneda(pre.montoPretencion, 'format');
            totalAmparo += Number(validateMontoMoneda(pre.montoPretencion, 'reset_format'));
        });
        setStateMontosAmparosCaso(auxMontosAmparo);
        setStateTotalAmparosCaso(validateMontoMoneda(totalAmparo, 'format'));

        // — Asíncrono: implicado + parámetros en paralelo —
        const loadAsync = async () => {
            const [response, paramResponse] = await Promise.all([
                getCasoImplicado(Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idImplicado: implicado })).toString('base64')),
                getParametros(Buffer.from(JSON.stringify({ rutcia: 0, parametro: 35 })).toString('base64'))
            ]);
            if (cancelled) return;

            const result = action === "provision" ? response[0]?.ultimaProvision : response[0]?.ultimaPropuestaIndeminizacion;
            setStateMoneda(result?.CodMonedaIngreso || codMonedaLocal);
            setStateComentario(result?.Comentario || "");
            setStateInstanciaProvision(result?.CodInstancia || "");
            setStateSituacionProvision(result?.CodSituacion?.toString() || "245005");
            setSituacionProvision(result?.CodSituacion?.toString() || "");
            setSituacionReserva(result?.Situacion?.toString() || "");
            setStateComentarioVizacion(result?.ComentarioVisado || "");
            setFechaActualizaPrevision(result?.FechaActualizacion);
            setFechaSiniestro(response[0]?.FechaSiniestro);
            setSecuencia(result?.Secuencia);
            setFolioDoc(result?.FolioDocumento);
            setInvolucrado({
                rut: response[0]?.RutInvolucrado,
                nombre: response[0]?.NombreInvolucrado,
                tipo: response[0]?.GlosaTipoInvolucrado,
                patente: response[0]?.Patente,
                lesionado: response[0]?.GlosaImplLesionado
            });
            setStateResponsabilidadAsegurado(response[0]?.GradoRespAsegurado || "");
            setStateAmparoAfectado(result?.AmparoAfectadoCIA || "");
            setAmparoAfectado(result?.AmparoAfectadoCIA || "");
            const gradoRespAsegurado = response[0]?.GradoRespAsegurado || "";
            const agrupacion = comboResponsabilidadAsegurado?.comboResponsabilidadAsegurado?.find(c => c.id === gradoRespAsegurado)?.agrupacion || "";
            setStatePorcRegla(agrupacion);
            setStatePorcConfirmado(response[0]?.PorcGradoRespAseg || agrupacion);
            const decisionInicial = response[0]?.ultimaProvision?.DecisionCIA?.toString() || "";
            setStateDecisionCia(decisionInicial);
            initialDecisionCia.current = decisionInicial;
            initialComentario.current = result?.Comentario || "";
            initialInstancia.current = result?.CodInstancia || "";
            initialResponsabilidad.current = response[0]?.GradoRespAsegurado || "";
            initialAmparoAfectado.current = result?.AmparoAfectadoCIA || "";
            if (result?.CodSituacion == ID_SITUACION_INFORME_OBJETADO) setStateComentarioAutorizacion(result?.ComentaSupervisor);
            if (origenVisar == 100) setTituloModal("REGISTRAR VALORIZACIÓN PEC");
            setParametro(paramResponse.valorParametro);
            const ultimaProvision = response[0]?.ultimaProvision;
            if (origenVisar == ID_TAREA_VISAR_VAL_PEC || origenVisar == 100) {
                const porcInicial = ultimaProvision?.PorcGradoRespAsegVigente || agrupacion;
                setStatePorcConfirmado(porcInicial);
                initialPorcConfirmado.current = porcInicial;
            } else if (origenVisar == ID_TAREA_AUTOR_RESERVA_CASO) {
                setStatePorcConfirmado(ultimaProvision?.PorcGradoRespAsegAutorizar || ultimaProvision?.PorcGradoRespAsegVigente || agrupacion);
            }

            setLoading(false);
            setDataReady(true);
        };

        loadAsync().catch(err => {
            console.error('Error cargando datos provisiones:', err);
            if (!cancelled) setLoading(false);
        });

        return () => { cancelled = true; };

    }, [implicado, listaProvisionesVigentes, amparosCia, comboResponsabilidadAsegurado]);

    const handleSelect = (k) => { setKey(k === key ? "" : k); }

    const handleChangeMontos = (type, value) => setStateMontos({ ...stateMontos, [type]: value });
    const handleChangeMontosAmparosCaso = (type, value) => setStateMontosAmparosCaso({ ...stateMontosAmparosCaso, [type]: value });

    const handleFocusBlur = (action, type, value) => {
        if (action === "focus") handleChangeMontos(type, validateMontoMoneda(value, 'reset_format'));
        else handleChangeMontos(type, validateMontoMoneda(value, 'format'));
    }
    const handleFocusBlurAmparpsCaso = (action, type, value) => {
        if (action === "focus") handleChangeMontosAmparosCaso(type, validateMontoMoneda(value, 'reset_format'));
        else handleChangeMontosAmparosCaso(type, validateMontoMoneda(value, 'format'));
    }

    const handleChangeObsCia = (key, value) => setStateObsCia({ ...stateObsCia, [key]: value });
    const handleVerObsAbogado = (obs) => { setObsAboModalContent(obs); setShowObsAboModal(true); };

    const validateMontoMoneda = (value, action) => {
        const strValue = value !== undefined && value !== null ? value.toString() : '';
        if (action === 'format') return formatoMonto(strValue);
        return Number(stateMoneda) === 30001 ? resetFormatoMontoSinPunto(strValue) : resetFormatoMonto(strValue);
    }

    const permissionProvision = () => {
        let counter = 0;
        if (["245005","245006","245002","245007"].includes(stateSituacionProvision)) {
            roles.forEach(value => {
                if (stateSituacionProvision === "245007") {
                    setPermissionCabecera(false); setPermissionGrilla(false); setPermissionButtons(false);
                    if (["0070ANDEF0","0070AUTPROV"].includes(value.rol)) counter++;
                    setPermissionComboSituacion(counter !== 0);
                } else if (changeSituacionProvision && stateSituacionProvision === "245002" && ["0070AUTPROV","0070ANDEF0"].includes(value.rol) && counter===0) {
                    counter++; setPermissionCabecera(false); setPermissionGrilla(false); setPermissionButtons(true); setPermissionComboSituacion(false);
                } else if (((stateSituacionProvision === "245005" && value.rol === "0070ANDEF0") || (stateSituacionProvision === "245002" && value.rol === "0070ANDEF0") || (stateSituacionProvision === "245006" && value.rol === "0070AUTPROV")) && counter===0) {
                    counter++; setPermissionCabecera(true); setPermissionGrilla(true); setPermissionButtons(true); setPermissionComboSituacion(false);
                } else if(counter===0) {
                    setPermissionCabecera(false); setPermissionGrilla(false); setPermissionButtons(false); setPermissionComboSituacion(false);
                }
            });
        } else {
            setPermissionCabecera(false); setPermissionGrilla(false); setPermissionButtons(false); setPermissionComboSituacion(false);
        }
    }

    const permissionIndemnizacion = () => {
        const tieneRolAndef = roles.some(v => v.rol==="0070ANDEF0");
        let permiso = tieneRolAndef && stateSituacionProvision != ID_SITUACION_INFORME_POR_AUTORIZAR;
        setPermissionCabecera(permiso); setPermissionGrilla(permiso); setPermissionButtons(permiso); setPermissionComboSituacion(false);
    }

    const handleVerMovimientosImplicado = (tipoMovimiento) => {
        setTipoMovimientoGrilla(tipoMovimiento);
        if (llaves) {
            setLoading(true);
            setShowModalProvisionesImplicado(true);
            setShowImplicadosHistorial(false);
            const query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], tipoMovimiento })).toString('base64');
            dispatch(obtenerProvisionesImplicados(query)).then(() => setLoading(false));
        }
    }

    const handleVerHistorialPretensiones = () => {
        if (llaves) {
            setLoading(true); setShowImplicadosHistorial(true); setShowModalProvisionesImplicado(false);
            const query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], idImplicado: implicado, tipoMovimiento: action==="provision"?261002:261003 })).toString('base64');
            dispatch(obtenerProvImplicadosHistorial(query)).then(() => setLoading(false));
        }
    }

    const handleShowPreInforme = async () => {
        if (folioDoc) {
            setLoading(true);
            const query = Buffer.from(JSON.stringify({ idCaso:String(llaves.idCaso), idImplicadoCaso:String(implicado), idCompania:String(llaves.idOrgCaso), idfolioCarga:folioDoc })).toString('base64');
            const response = await verPreInforme(query);
            setLoading(false);
            descargarArchivo(response);
        }
    }

    const esSoloActualizaDecisionMonto = () => {
        if (!secuencia) return false;
        const montoActualRaw = Number(resetFormatoMonto(montoAutorizado || 0));
        const montoInicialRaw = Number(resetFormatoMonto(initialMontoAutorizado.current || 0));
        const decisionCambio = stateDecisionCia !== initialDecisionCia.current;
        const montoCambio = montoActualRaw !== montoInicialRaw;
        if (!decisionCambio && !montoCambio) return false;
        const coberturasCambiaron = Object.keys(initialMontos.current).some(k => {
            const init = Number(validateMontoMoneda(initialMontos.current[k] || 0, 'reset_format'));
            const curr = Number(validateMontoMoneda(stateMontos[k] || 0, 'reset_format'));
            return init !== curr;
        });
        const otrosCampos = stateComentario !== initialComentario.current ||
            stateInstanciaProvision !== initialInstancia.current ||
            String(statePorcConfirmado) !== String(initialPorcConfirmado.current) ||
            String(stateResponsabilidadAsegurado) !== String(initialResponsabilidad.current) ||
            String(stateAmparoAfectado) !== String(initialAmparoAfectado.current);
        return !coberturasCambiaron && !otrosCampos;
    };

    const ajustarProvision = () => roles.some(v => v.rol==="0070ANDEF0") && situacionProvision==="245002";

    const handleCloseToast = () => {
        setShowToast(false);
        if(responseData?.code===1){
            handleClose();
            // Marca la tarea como en proceso y recarga (en ese orden) desde la grilla.
            if (onTareaGestionada) { onTareaGestionada(); return; }
        }
        const query = Buffer.from(JSON.stringify({ idCaso:llaves["idCaso"], idUsuario:rutUsuario })).toString('base64');
        dispatch(obtenerTareasPendientes(query));
    }
    useEffect(() => {
        const reserva = reservaCia?.reservaCia?.coberturasPoliza?.find(r => r.montoPretencion > 0);
        const montoInicial = reserva?.montoAutoConciliar != null ? validateMontoMoneda(reserva.montoAutoConciliar, 'format') : '';
        setMontoAutorizado(montoInicial);
        initialMontoAutorizado.current = montoInicial;
        setErrorMontoAutorizado('');
    }, [reservaCia]);

    useEffect(() => {
        const total = Object.keys(stateMontos).reduce((acc, key) => {
            const val = stateMontos[key];
            const num = Number(validateMontoMoneda(val || 0, 'reset_format'));
            return acc + (isNaN(num) ? 0 : num);
        }, 0);
        setStateMontoTotal(validateMontoMoneda(total, 'format'));
        setMontoReserva(parseInt(total * (Number(statePorcConfirmado) / 100)));
    }, [stateMontos, statePorcConfirmado]);

    useEffect(() => {
        const total = Object.keys(stateMontosAmparosCaso).reduce((acc, key) => {
            const val = stateMontosAmparosCaso[key];
            const num = Number(validateMontoMoneda(val || 0, 'reset_format'));
            return acc + (isNaN(num) ? 0 : num);
        }, 0);
        setStateTotalAmparosCaso(validateMontoMoneda(total, 'format'));
    }, [stateMontosAmparosCaso]);

    const formik = useFormik({
        initialValues: {
            codMonedaIngreso: "",
            fechaActualizacion: "",
            comentario: "",
            idInstanciaProvision: "",
            situacionProvision: "",
            informe: "",
            coberturas:[],
            responsabilidadAsegurado: "",
            porcRegla: "",
            porcConfirmado: "",
            amparoAfectado: "",
            montoReserva: "",
            amparosCaso:[],
            porcConfirmadoOriginal: statePorcConfirmado,
            comentarioAutorizacion:"",
            amparoActualizado: false,
            decisionCia:"",
            montoAutorizado:""
        },
        validationSchema: validationSchemasVisaProvision(fechaActualizaPrevision, fechaSiniestro),
        onSubmit: async (data) => {
            const mtoAutRaw = Number(validateMontoMoneda(montoAutorizado, 'reset_format'));
            if (mtoAutRaw > 0 && montoReserva > 0 && mtoAutRaw > montoReserva) {
                setErrorMontoAutorizado('El monto autorizado no puede superar el monto reserva.');
                return;
            }
            if (Number(resetFormatoMonto(stateMontoTotal)) > 0) {

                let dataResultForm = {...data};
                dataResultForm.idCaso = llaves['idCaso'];
                dataResultForm.idImplicadoCaso = implicado;
                dataResultForm.idOrganizacion = llaves['idOrgCaso'];
                dataResultForm.codMonedaLocal = 30001;
                dataResultForm.idUsuario = rutUsuario;
                dataResultForm.secuenciaProvision = secuencia;
                dataResultForm.secuenciaPropuesta = secuencia;
                dataResultForm.origenVisar = origenVisar;
                dataResultForm.idInstancia = dataResultForm.idInstanciaProvision;
                dataResultForm.montoReserva = Number(resetFormatoMonto(dataResultForm.montoReserva));
                dataResultForm.montoAutorizado = Number(resetFormatoMonto(dataResultForm.montoAutorizado));

                dataResultForm.coberturas = listaProvisionesVigentes?.listaProvisionesVigentes?.coberturasPoliza.map(pre => ({
                    id: pre.id,
                    codigoCobertura: pre.codigoCobertura,
                    codigoAmparoPadre: pre.codigoAmparoPadre,
                    montoPretension: Number(resetFormatoMonto(stateMontos["state" + pre.codigoCobertura] || 0)),
                    actualizaMonto: pre.actualizaMonto || "N",
                    ...(isPEC ? { obsAnalistaCIA: stateObsCia[`obscia${pre.codigoCobertura}`] || null } : {})
                }));
                dataResultForm.amparosCaso = amparosCaso.map(pre => ({
                    id: pre.id,
                    codigoCobertura: pre.codigoCobertura,
                    codigoAmparoPadre: pre.codigoAmparoPadre,
                    montoPretension: Number(resetFormatoMonto(stateMontosAmparosCaso["state" + pre.codigoCobertura] || 0)),
                    actualizaMonto: pre.actualizaMonto || "N"
                }));

                dataResultForm.fechaActualizacion = data.fechaActualizacion ? data.fechaActualizacion.split('-').join('') : "";
                dataResultForm.registraProvision = registraProvision;
                dataResultForm.idTrxOrigen = idTrxOrigen;

                if (origenVisar == 100 && esSoloActualizaDecisionMonto()) {
                    dataResultForm.soloActualizaDecisionMonto = true;
                }

                setPendingData(dataResultForm);
                
                //if(action==="provision") updateProvisiones(dataResultForm);
                //else setShowModalConfirmacion(true);

                if (amparoAfectado != stateAmparoAfectado && origenVisar !=100) {
                    setConfirmMessage("Amparo CIA Afectado será actualizado para todos los implicados con informe de reserva.");
                    setShowConfirm(true);
                    dataResultForm.amparoActualizado = true;
                    return;
                }
                updateProvisiones(dataResultForm)

            } else setShowModalTotal(true);
        }
    });
    const updateProvisiones = async (data, confirmado = false) => {

        const dataResultEnviar = data;//action === "provision" ? data : dataResult;

        setShowModalConfirmacion(false);
        setLoading(true);

        const payload = {
            ...dataResultEnviar,
            confirmado
        };

        let response = null;

        if (origenVisar == 100) {
            response = await registraValorizacionPEC(payload);
        } else {
            response = action === "provision"
                ? await actualizarProvisiones(payload)
                : await actualizarIndemnizacion(payload);
        }

        setLoading(false);

        const resp = response?.respuestaActProvisiones ? response?.respuestaActProvisiones : response?.respuestaResgistroValPEC;

        if (resp?.code === 100 && !confirmado) {
            setPendingData(dataResultEnviar);
            setConfirmMessage(resp.message);
            setShowConfirm(true);
            return;
        }

        setResponseData(resp);
        setShowToast(true);
    }
    const handleCancelar = () => {
        setShowConfirm(false);
    }
    const handleConfirmar = async () => {
        setShowConfirm(false);
        await updateProvisiones(pendingData, true);
    }
    const autorizarReserva = async (accionAutorizar) => {

        setErrorComentario('');
        if (accionAutorizar == 2 && stateComentarioAutorizacion == "") {
            setErrorComentario('El comentario es obligatorio');
            return;
        }

        let data = {
            idCaso: llaves['idCaso'],
            idImplicadoCaso: implicado,
            idOrganizacion: llaves['idOrgCaso'],
            idUsuario: rutUsuario,
            accionAutorizar: accionAutorizar,
            secuenciaInformeReserva: secuenciaInforme,
            secuenciaInformeValPec: secuencia,
            comentarioAutorizacion: stateComentarioAutorizacion,
            idTrxOrigen: idTrxOrigen,
            porcConfirmado: statePorcConfirmado
        }

        setLoading(true);
        const response = await autorizaRechazaReserva(data)
        setLoading(false);
        setResponseData(response?.respuestaGestionReserva);
        setShowToast(true);
        
    }
    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                <Card.Header style={{ backgroundColor:'#4F517A', color:'white' }}>
                    {tituloModal ? tituloModal : action === "provision" ? (cfg_form44?.cfg_form44['modalvisarprovisiones-title-modal']): cfg_form44?.cfg_form44['modalvisarprovisiones-title-modal-ppta']}
                </Card.Header>

                {situacionProvision != ID_SITUACION_INFORME_VIGENTE && situacionReserva && origenVisar == 100 ? ( 
                    <Container className='mb-3'>
                            <Row>
                                <Col md='12'>
                                    <Form.Text style={{color:'#e79b0d', fontWeight:'bold'}}>
                                        No se pueden ingresar reserva, existe reserva en estado {situacionReserva}.
                                    </Form.Text>
                                </Col>
                            </Row>
                    </Container>
                ) : ( 

                    <Container>
                        <Form onSubmit={formik.handleSubmit}>
                            <Container className='mb-3'>
                                <Row>
                                    {["rut","nombre","tipo","patente","lesionado"].map((field,index)=>(
                                        <Col key={index} md={field==="nombre"?"3":"2"}>
                                            <Form.Label className='mb-0 mt-2' style={{ fontWeight:'bold', fontSize:'14px' }}>
                                                {cfg_form44?.cfg_form44[`modalvisarprovisiones-lbl-${field}`]}
                                            </Form.Label>
                                            <br/>
                                            <Form.Text className='mb-3'>
                                                {involucrado[field]}
                                            </Form.Text>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                            <Container className='mb-4'>
                                {/*<Tabs id='uncontrolled-tab-example' activeKey={key} onSelect={handleSelect}>
                                    <Tab eventKey="cobertura" title={cfg_form44?.cfg_form44['modalvisarprovisiones-tab-coberturas']}>
                                        <CoberturaPoliza />
                                    </Tab>
                                </Tabs>*/}
                                <hr style={{ borderTop: '3px solid #04005D' }}></hr>
                                <Row className='form'>
                                    <Col md='3'>
                                        <Form.Label className="is_required">{cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-moneda']}</Form.Label>
                                        <Form.Select disabled={!permissionCabecera} className='mt-2'
                                            name='codMonedaIngreso'
                                            value={formik.values.codMonedaIngreso = stateMoneda}
                                            onChange={e=>{formik.handleChange(e); setStateMoneda(e.target.value)}} >
                                            <option value=''>Seleccione...</option>
                                            {comboMonedas?.filter(m => [codMonedaLocal, codMonedaConsolida].includes(Number(m.id))).map(c => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.codMonedaIngreso && formik.touched.codMonedaIngreso &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.codMonedaIngreso}</Form.Text>}
                                    </Col>

                                    <Col md='3'>
                                        <Form.Label className="is_required">{cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-fechaact']}</Form.Label>
                                        <Form.Control disabled={!permissionCabecera} className='mt-2' type="date"
                                            min={parametro && minDate(parametro)} max={today()}
                                            value={formik.values.fechaActualizacion = stateFechaActualizacion}
                                            onChange={e=>{formik.handleChange(e); setStateFechaActualizacion(e.target.value)}}
                                            onBlur={formik.handleBlur} />
                                        {formik.errors.fechaActualizacion && formik.touched.fechaActualizacion &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.fechaActualizacion}</Form.Text>}
                                    </Col>

                                    {/* Instancia y situación */}
                                    <Col md='3'>
                                        <Form.Label className="is_required">
                                            {action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-instanciaprovi']:cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-instanciappta']}
                                        </Form.Label>
                                        <Form.Select disabled={!permissionCabecera} className='mt-2'
                                            name='idInstanciaProvision'
                                            value={formik.values.idInstanciaProvision = stateInstanciaProvision}
                                            onChange={e=>{formik.handleChange(e); setStateInstanciaProvision(e.target.value)}}>
                                            <option value=''>Seleccione...</option>
                                            {comboInstanciasProvisiones?.comboInstanciasProvisiones?.map(c => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.idInstanciaProvision && formik.touched.idInstanciaProvision &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.idInstanciaProvision}</Form.Text>
                                        }
                                    </Col>

                                    <Col md='3'>
                                        <Form.Label className="is_required">{cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-situacion']}</Form.Label>
                                        <Form.Select disabled={!permissionComboSituacion} className='mt-2'
                                            name='situacionProvision'
                                            value={formik.values.situacionProvision = stateSituacionProvision}
                                            onChange={e=>{formik.handleChange(e); setStateSituacionProvision(e.target.value); setChangeSituacionProvision(true);}}>
                                            <option disabled={stateSituacionProvision==='245007'} value='245005'>Por Visar</option>
                                            <option disabled={stateSituacionProvision==='245007'} value='245006'>Por Autorizar</option>
                                            <option value='245007'>Actualizar Core CIA</option>
                                            <option value='245002'>Vigente</option>
                                        </Form.Select>
                                        {formik.errors.situacionProvision && formik.touched.situacionProvision &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.situacionProvision}</Form.Text>
                                        }
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label className="is_required">{cfg_form44?.cfg_form44['modalvisarprovisiones-input-comentario']}</Form.Label>
                                        <Form.Control disabled={!permissionCabecera} className='mt-2'
                                            value={formik.values.comentario = stateComentario}
                                            onChange={e=>{formik.handleChange(e); setStateComentario(e.target.value)}} />
                                            {formik.errors.comentario && formik.touched.comentario &&
                                                <Form.Text style={{color:'red'}}>{formik.errors.comentario}</Form.Text>
                                            }
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label>{cfg_form44?.cfg_form44['modalvisarprovisiones-input-comentario-visa']}</Form.Label>
                                        <Form.Control disabled={!permissionCabecera} className='mt-2'
                                            name='comentarioVizacion'
                                            value={formik.values.comentarioVizacion = stateComentarioVizacion}
                                            onChange={e=>{formik.handleChange(e); setStateComentarioVizacion(e.target.value)}} />
                                    </Col>
                                    <hr style={{ color: '#04005D', height: '4px', marginTop: '20px', marginBottom: '5' }}></hr>
                                    <Col md='3'>
                                        <Form.Label className="is_required">
                                            {action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-respasegurado']:cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-respasegurado']}
                                        </Form.Label>
                                        <Form.Select disabled={!permissionCabecera} className='mt-2'
                                            name='responsabilidadAsegurado'
                                            value={formik.values.responsabilidadAsegurado = stateResponsabilidadAsegurado}
                                            onChange={e=>{
                                                formik.handleChange(e); 
                                                setStateResponsabilidadAsegurado(e.target.value);
                                                let agrupacion = comboResponsabilidadAsegurado?.comboResponsabilidadAsegurado?.find(c => c.id == e.target.value)?.agrupacion || "";
                                                setStatePorcRegla(agrupacion);
                                                setStatePorcConfirmado(agrupacion);
                                            }}>
                                            <option value=''>Seleccione...</option>
                                            {comboResponsabilidadAsegurado?.comboResponsabilidadAsegurado?.map(c => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.responsabilidadAsegurado && formik.touched.responsabilidadAsegurado &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.responsabilidadAsegurado}</Form.Text>
                                        }
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label>{cfg_form44?.cfg_form44['modalvisarprovisiones-lbl-porcregla']}</Form.Label>
                                        <Form.Control  className='mt-2'
                                            disabled
                                            name='porcRegla'
                                            value={formik.values.porcRegla = statePorcRegla}/>
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label>{cfg_form44?.cfg_form44['modalvisarprovisiones-input-porcconfirm']}</Form.Label>
                                        <Form.Control disabled={!permissionCabecera} className='mt-2'
                                            name='porcConfirmado'
                                            min={0}
                                            max={100}
                                            value={formik.values.porcConfirmado = statePorcConfirmado}
                                            style={{
                                                backgroundColor: statePorcConfirmado != statePorcRegla ? '#fff3cd' : ''
                                            }}
                                            onChange={e => {
                                                const value = e.target.value;
                                                if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                                                    setStatePorcConfirmado(value);
                                                    formik.setFieldValue('porcConfirmado', value);
                                                }
                                            }}
                                        />
                                    </Col>                                
                                    <Col md='3'>
                                        <Form.Label className="is_required">
                                            {action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-amparocia']:cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-amparocia']}
                                        </Form.Label>
                                        <Form.Select disabled={!permissionCabecera} className='mt-2'
                                            name='amparoAfectado'
                                            value={formik.values.amparoAfectado = stateAmparoAfectado}
                                            onChange={e=>{formik.handleChange(e); setStateAmparoAfectado(e.target.value)}}>
                                            <option value=''>Seleccione...</option>
                                            {amparosAfectados && amparosAfectados?.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.amparoAfectado && formik.touched.amparoAfectado &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.amparoAfectado}</Form.Text>}
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className="is_required">
                                            {action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-mtoreserva']:cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-mtoreserva']}
                                        </Form.Label>
                                        <Form.Control
                                            className='mt-2'
                                            disabled
                                            aria-label='Default select example'
                                            autoComplete='off'                                        
                                            name='montoReserva'
                                            value={(formik.values.montoReserva = validateMontoMoneda(montoReserva, 'format'))}
                                            error={formik.errors.montoReserva}
                                        ></Form.Control> 
                                    </Col>                                    
                                </Row>
                                <Row className='form'>
                                    <Col md='3'>
                                        <Form.Label className="label">{cfg_form44?.cfg_form44['modalvisarprovisiones-cmb-decisioncia']}</Form.Label>
                                        <Form.Select disabled={!permissionCabecera} className='mt-2'
                                            name='decisionCia'
                                            value={formik.values.decisionCia = stateDecisionCia}
                                            onChange={e=>{formik.handleChange(e); setStateDecisionCia(e.target.value)}} >
                                            <option value=''>Seleccione...</option>
                                            {comboDecision?.comboDecision?.map(c => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.decisionCia && formik.touched.decisionCia &&
                                            <Form.Text style={{color:'red'}}>{formik.errors.decisionCia}</Form.Text>}
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className="label">
                                            {action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-input-montoAutorizado']:cfg_form44?.cfg_form44['modalvisarprovisiones-input-montoAutorizado']}
                                        </Form.Label>
                                        <Form.Control
                                            className='mt-2'
                                            autoComplete='off'
                                            name='montoAutorizado'
                                            value={formik.values.montoAutorizado = montoAutorizado}
                                            onChange={e => { setMontoAutorizado(e.target.value); formik.setFieldValue('montoAutorizado', e.target.value); setErrorMontoAutorizado(''); }}
                                            onBlur={e => {
                                                const raw = Number(validateMontoMoneda(e.target.value, 'reset_format'));
                                                setMontoAutorizado(validateMontoMoneda(e.target.value, 'format'));
                                                if (raw > 0 && montoReserva > 0 && raw > montoReserva) {
                                                    setErrorMontoAutorizado('El monto autorizado no puede superar el monto reserva.');
                                                }
                                            }}
                                            onFocus={e => setMontoAutorizado(validateMontoMoneda(e.target.value, 'reset_format'))}
                                            onKeyPress={e => moneyPunto(e, Number(stateMoneda) !== 30001)}
                                            error={formik.errors.montoAutorizado}
                                        />
                                        {errorMontoAutorizado && <Form.Text style={{color:'red'}}>{errorMontoAutorizado}</Form.Text>}
                                    </Col>  
                                </Row>
                                {/* Tabla de coberturas */}
                                <Container className="mt-3">
                                    <div className="container_table">
                                        <div className="container_table_header d-flex align-items-center">
                                            <span className="me-3">{action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-vig']:cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-ppta-vig']}</span>
                                            {isPEC && listaProvisionesVigentes?.listaProvisionesVigentes?.coberturasPoliza?.[0] && (() => {
                                                const cob0 = listaProvisionesVigentes.listaProvisionesVigentes.coberturasPoliza[0];
                                                return (
                                                    <>
                                                        <span className="me-3" style={{opacity:0.4}}>|</span>
                                                        <span style={{fontSize:'14px', fontWeight:'normal', color:'#d4d0f0'}}>
                                                            {cob0.glosaEstado && <span className="me-3"><span style={{opacity:0.7}}>Estado:</span> {cob0.glosaEstado}</span>}
                                                            {cob0.fechaRegistroFmt && <span className="me-3"><span style={{opacity:0.7}}>Fecha Registro:</span> {cob0.fechaRegistroFmt}</span>}
                                                            {cob0.usuario && <span><span style={{opacity:0.7}}>Usuario:</span> {cob0.usuario}</span>}
                                                        </span>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th style={{width:'30%'}}>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-cobertura']}</th>
                                                    <th style={{whiteSpace:'nowrap'}}>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-monto']} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                                                    {isPEC ? (
                                                        <>
                                                            <th>Obs. CIA</th>
                                                            <th style={{width:'50px', textAlign:'center'}}>Obs. Abogado</th>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-estado']}</th>
                                                            <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-fecharegistro']}</th>
                                                            <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-usuario']}</th>
                                                        </>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listaProvisionesVigentes?.listaProvisionesVigentes?.coberturasPoliza.map((pre,index)=>{
                                                    const montoKey = `state${pre.codigoCobertura}`;
                                                    const obsCiaKey = `obscia${pre.codigoCobertura}`;
                                                    return (
                                                        <tr key={index}>
                                                            <td>{pre.cobertura}</td>
                                                            <td style={{width:'130px'}}>
                                                            {pre.actualizaMonto === 'S' ? (
                                                                <Form.Control
                                                                    disabled={!permissionGrilla}
                                                                    id={montoKey}
                                                                    name={montoKey}
                                                                    autoComplete='off'
                                                                    readOnly={stateMoneda === "" || pre.actualizaMonto==='N'}
                                                                    value={formik.values[montoKey] = stateMontos[montoKey]}
                                                                    onChange={e=>{formik.handleChange(e); handleChangeMontos(montoKey, e.target.value)}}
                                                                    onBlur={e=>handleFocusBlur('blur', montoKey, e.target.value)}
                                                                    onFocus={e=>handleFocusBlur('focus', montoKey, e.target.value)}
                                                                    onKeyPress={e=>moneyPunto(e, Number(stateMoneda)!==30001)}
                                                                    style={{width:'120px'}}
                                                                />
                                                            ) : (
                                                                formatoMonto(pre.montoCobertura, false)
                                                            )}
                                                            </td>
                                                            {isPEC ? (
                                                                <>
                                                                    <td>
                                                                        <Form.Control
                                                                            as="textarea"
                                                                            rows={1}
                                                                            disabled={!permissionGrilla}
                                                                            value={stateObsCia[obsCiaKey] || ''}
                                                                            onChange={e => handleChangeObsCia(obsCiaKey, e.target.value)}
                                                                            style={{resize:'none', width:'100%'}}
                                                                        />
                                                                    </td>
                                                                    <td style={{textAlign:'center', verticalAlign:'middle'}}>
                                                                        <MdComment
                                                                            size={22}
                                                                            title={pre.obsResponsable ? pre.obsResponsable : 'Sin observación'}
                                                                            style={{
                                                                                color: pre.obsResponsable ? '#4F517A' : '#ccc',
                                                                                cursor: pre.obsResponsable ? 'pointer' : 'default'
                                                                            }}
                                                                            onClick={() => pre.obsResponsable && handleVerObsAbogado(pre.obsResponsable)}
                                                                        />
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <td>{pre.glosaEstado}</td>
                                                                    <td>{pre.fechaRegistroFmt}</td>
                                                                    <td>{pre.usuario}</td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    )
                                                })}
                                                <tr>
                                                    <td><strong>{action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-lbl-total']:"Total Valorización"}</strong></td>
                                                    <td><strong>{stateMontoTotal} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                                                    <td colSpan={isPEC ? 2 : 3}>
                                                        <FaSearch size={25} title={folioDoc?"Ver preinforme":"No existe preinforme"} style={{color:'gray', cursor: folioDoc?'pointer':'not-allowed'}} onClick={handleShowPreInforme}/>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Container>
                                {/* Tabla de RESERVA */}
                                <Container className="mt-3">
                                    <div className="container_table">
                                        <div className="container_table_header">{action==="provision" ? cfg_form44?.cfg_form44['modalvisarprovisiones-subtitle-reserva-cia'] : cfg_form44?.cfg_form44['modalvisarprovisiones-subtitle-reserva-cia']}</div>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-cobertura']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-monto']} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-estado']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-fecharegistro']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-usuario']}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reservaCia?.reservaCia?.coberturasPoliza
                                                    ?.filter(reserva => reserva.montoPretencion > 0)
                                                    .map((reserva, index) => {
                                                    return (
                                                        <tr key={index}>
                                                        <td>{reserva.cobertura}</td>
                                                        <td>
                                                            {formatoMonto(reserva.montoPretencion, false)}
                                                        </td>
                                                        <td>{reserva.glosaEstado}</td>
                                                        <td>{reserva.fechaRegistroFmt}</td>
                                                        <td>{reserva.usuario}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Container>
                                {/* Tabla de Amparos Caso */}
                                <Container className="mt-3">
                                    <div className="container_table">
                                        <div className="container_table_header">{action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-amparos-caso']:cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-amparos-caso']}</div>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-cobertura']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-monto']} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-estado']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-fecharegistro']}</th>
                                                    <th>{cfg_form44?.cfg_form44['modalvisarprovisiones-grilla-usuario']}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {amparosCaso?.map((pre,index)=>{
                                                    const montoKey = `state${pre.codigoCobertura}`;
                                                    return (
                                                        <tr key={index}>
                                                            <td>{pre.cobertura}</td>
                                                            <td>
                                                            {pre.actualizaMonto === 'S' ? (
                                                                <Form.Control
                                                                    disabled={!permissionGrilla}
                                                                    id={montoKey}
                                                                    name={montoKey}
                                                                    autoComplete='off'
                                                                    readOnly={stateMoneda === "" || pre.actualizaMonto==='N'}
                                                                    value={formik.values[montoKey] = stateMontosAmparosCaso[montoKey]}
                                                                    onChange={e=>{formik.handleChange(e); handleChangeMontosAmparosCaso(montoKey, e.target.value)}}
                                                                    onBlur={e=>handleFocusBlurAmparpsCaso('blur', montoKey, e.target.value)}
                                                                    onFocus={e=>handleFocusBlurAmparpsCaso('focus', montoKey, e.target.value)}
                                                                    onKeyPress={e=>moneyPunto(e, Number(stateMoneda)!==30001)}
                                                                />
                                                            ) : (
                                                                formatoMonto(pre.montoCobertura, false)
                                                            )}
                                                            </td>
                                                            <td>{pre.glosaEstado}</td>
                                                            <td>{pre.fechaRegistroFmt}</td>
                                                            <td>{pre.usuario}</td>
                                                        </tr>
                                                    )
                                                })}
                                                <tr>
                                                    <td><strong>{action==="provision"?cfg_form44?.cfg_form44['modalvisarprovisiones-lbl-total']:"Total Amparos Caso"}</strong></td>
                                                    <td><strong>{stateTotalAmparosCaso} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                                                    <td colSpan={3}></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Container>
                                <Container className='mb-4'>
                                    {stateSituacionProvision == ID_SITUACION_INFORME_POR_AUTORIZAR &&
                                    <Row className='form'>
                                        <Col md='12'>
                                            <Form.Label className="is_required">{cfg_form44?.cfg_form44['modalvisarprovisiones-input-comentario']} Autorización</Form.Label>
                                            <Form.Control className='mt-2'
                                                value={formik.values.comentarioAutorizacion = stateComentarioAutorizacion}
                                                onChange={e=>{
                                                    formik.handleChange(e); 
                                                    setStateComentarioAutorizacion(e.target.value)
                                                    setErrorComentario('');
                                                }} />
                                            {errorComentario  &&
                                                <Form.Text style={{color:'red'}}>{errorComentario}</Form.Text>}
                                        </Col>
                                    </Row>
                                    }   
                                    {stateSituacionProvision == ID_SITUACION_INFORME_OBJETADO &&
                                    <Row className='form'>
                                        <Col md='12'>
                                            <Form.Label className='mb-0 mt-2' style={{ fontWeight:'bold', fontSize:'14px' }}>{cfg_form44?.cfg_form44['modalvisarprovisiones-input-comentario']} Objeción</Form.Label>
                                            <br/>
                                            <Form.Text className='mb-3'>
                                                {stateComentarioAutorizacion}
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                    } 
                                </Container>
                            </Container>
                            
                            {showToast && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={responseData}
                                ></Mensajes>
                            }
                            <hr style={{ borderTop: '3px solid #04005D' }}></hr>
                            {/* Botones */}
                            <Container>
                                <Row>
                                    <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>
                                            {cfg_form44?.cfg_form44['modalvisarprovisiones-btn-volver']}
                                        </Button>
                                        {action!=="provision" &&
                                            <Button className='m-2 w-auto' variant='verGrilla' onClick={()=>handleVerMovimientosImplicado(261001)}>
                                                {cfg_form44?.cfg_form44['modalvisarprovisiones-btn-verpretemsiones']}
                                            </Button>
                                        }
                                        <Button className='m-2 w-auto' variant='verGrilla' onClick={()=>handleVerMovimientosImplicado(action==="provision"?261002:261003)}>
                                            {cfg_form44?.cfg_form44['modalvisarprovisiones-btn-implicados']}
                                        </Button>
                                        <Button className='m-2' variant='verGrilla' onClick={handleVerHistorialPretensiones}>
                                            {cfg_form44?.cfg_form44['modalvisarprovisiones-btn-historial']}
                                        </Button>
                                        {(stateSituacionProvision != ID_SITUACION_INFORME_POR_AUTORIZAR && origenVisar !=100) &&
                                            <Button type="submit" className='m-2' variant='actualizar' disabled={!permissionButtons}>
                                                {ajustarProvision()?"Ajustar":cfg_form44?.cfg_form44['modalvisarprovisiones-btn-actualizar']}
                                            </Button>
                                        }
                                        {(stateSituacionProvision == ID_SITUACION_INFORME_POR_AUTORIZAR && origenVisar !=100) &&
                                            <div>
                                                <Button className='m-2' variant='objetar' onClick={()=>autorizarReserva(2)}>
                                                    Objetar
                                                </Button>
                                                <Button className='m-2' variant='actualizar' onClick={()=>autorizarReserva(1)}>
                                                    Autorizar
                                                </Button>
                                            </div>
                                        }
                                        {(origenVisar == 100) &&
                                            <div>
                                                <Button type="submit" className='m-2' variant='objetar'>
                                                    {!secuencia ? `Ingresar` : `Actualizar`}
                                                </Button>
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </Container>
                )}
            </Card>

            {/* Modales */}
            <Modal show={showModalTotal} onHide={()=>setShowModalTotal(false)} size='md'>
                <Card>
                    <Card.Header style={{ backgroundColor:'#e8761a', color:'white' }}>Información</Card.Header>
                    <Card.Body>{action==="provision"?"Monto total Provisión deber ser mayor a 0.":"Monto total Valorización PEC deber ser mayor a 0."}</Card.Body>
                    <Card.Footer className='d-flex justify-content-center'>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={()=>setShowModalTotal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showModalConfirmacion} onHide={()=>setShowModalConfirmacion(false)} size='md'>
                <Card>
                    <Card.Header style={{ backgroundColor:'#e8761a', color:'white' }}>Confirmación</Card.Header>
                    <Card.Body>{registraProvision?"Esta propuesta actualizará provisión al implicado, ¿Desea continuar?":"Esta propuesta NO actualizará provisión al implicado, ¿Desea continuar?"}</Card.Body>
                    <Card.Footer className='d-flex justify-content-center'>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={()=>setShowModalConfirmacion(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={()=>updateProvisiones()}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>
            <Modal show={showConfirm} onHide={handleCancelar} backdrop="static" keyboard={false} centered>
                <Modal.Header style={{ backgroundColor:'#e8761a', color:'white' }} closeButton>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {confirmMessage}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleConfirmar}>
                        Aceptar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showObsAboModal} onHide={() => setShowObsAboModal(false)} size='md' centered>
                <Modal.Header style={{ backgroundColor:'#4F517A', color:'white' }} closeButton>
                    <Modal.Title>Observación Abogado</Modal.Title>
                </Modal.Header>
                <Modal.Body>{obsAboModalContent}</Modal.Body>
                <Modal.Footer>
                    <Button variant='outline-secondary' onClick={() => setShowObsAboModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            {showModalProvisionesImplicado && <GrillaPrevisionesImplicados action={action} setShowModalProvisionesImplicado={setShowModalProvisionesImplicado} showModalProvisionesImplicado={showModalProvisionesImplicado} />}

            <style type='text/css'>{`
                .btn-verGrilla{background-color:#55B2CE;color:#FFF;width:168px;}
                .btn-verGrilla:hover{background-color:#87c9dc;color:#FFF;}
                .is_required:after{content:"(*)";margin-left:2px;color:#000;font-weight:500;font-size:12pt;}
                .form{margin-top:5px;}
                .form label{font-weight:bold;font-size:14px;margin-bottom:0;margin-top:5px;}
                .container_table_header{padding:10px 20px;background-color:#716e9e;border-radius:5px;color:white;}
                .btn-provisiones{background-color:#F0AD3E;color:#FFF;width:140px;}
                .btn-provisiones:hover{background-color:#e1b97f;color:#FFF;}
                .btn-objetar {
                    background-color: #e79d2e;
                    color: #FFFFFF;
                    width: 140px;
                }
                .btn-objetar:hover{
                    background-color: #cf9b4c;
                    color: #FFFFFF;
                }
            `}</style>
        </Fragment>
    );
}

export default Provisiones;
